import React, { useMemo } from "react";
import EttersendelserCommon from "../../Detalj/Ettersendelser";
import { useDispatch, useSelector } from "react-redux";

import { getIleggelseEttersendelserEttersendelsebrevPdf } from "../../../../actions/ileggelseEttersendelsebrevActions";

const Ettersendelser = () => {
  const ileggelseEttersendelser = useSelector(
    (store) => store.ileggelseEttersendelser,
  );
  const bybetjenter = useSelector((store) => store.bybetjenter);
  const ettersendelser = useMemo(
    () => getEttersendelserFraBetjenter(ileggelseEttersendelser, bybetjenter),
    [ileggelseEttersendelser, bybetjenter],
  );

  const dispatch = useDispatch();

  const handleGetIleggelseEttersendelserEttersendelsebrevPdf = (
    ileggelseEttersendelseBrevId,
  ) => {
    dispatch(
      getIleggelseEttersendelserEttersendelsebrevPdf(
        ileggelseEttersendelseBrevId,
      ),
    );
  };
  return (
    <EttersendelserCommon
      ettersendelser={ettersendelser}
      getEttersendelserEttersendelsebrevPdf={
        handleGetIleggelseEttersendelserEttersendelsebrevPdf
      }
    />
  );
};

const getEttersendelserFraBetjenter = (ettersendelser, bybetjenter) => {
  if (!Array.isArray(bybetjenter)) return ettersendelser;
  const objectOfBybetjenter = Object.assign(
    {},
    ...bybetjenter.map((bybetjent) => ({ [bybetjent.id]: { ...bybetjent } })),
  );

  return (
    ettersendelser &&
    ettersendelser
      .filter((ettersendelse) => ettersendelse.betjentId)
      .map((ettersendelseFraBetjent) => {
        const bybetjent =
          objectOfBybetjenter[ettersendelseFraBetjent.betjentId];
        return {
          ...ettersendelseFraBetjent,
          tjenestenummer: bybetjent && bybetjent.nummer,
        };
      })
      .sort((a, b) => {
        if (a.ettersendelseDato > b.ettersendelseDato) {
          return -1;
        } else if (a.ettersendelseDato < b.ettersendelseDato) {
          return 1;
        } else {
          return 0;
        }
      })
  );
};

export default Ettersendelser;
